import ModelMappingValueOriginObjectModelProperty from "~/models/mapping/modelMappingValueOriginObjectModelProperty";
import ModelMappingValueOriginSalesforce from "~/models/mapping/modelMappingValueOriginSalesforce";
import {SalesforceApiDataType} from "~/enums/salesforceApiDataType";
import {ObjectModelPropertyRootType as omt, ObjectModelPropertyRootType} from "~/enums/objectModelPropertyType";
import {FormElementType} from "../../../enums/formElementType";
import {InputFormatType} from "../../../../formability/form_builder/models/inputFormatType";
import {PickListSelectionType} from "~/enums/pickListSelectionType";
import ModelMappingValueOriginFormElement from "~/models/mapping/modelMappingValueOriginFormElement";
import {
  baseModelPropertyIncompatibleTypes, dateTimeModelPropertyIncompatibleTypes,
  numberModelPropertyIncompatibleTypes, pickListModelPropertyIncompatibleTypes,
  shortTextModelPropertyIncompatibleTypes
} from "~/models/mapping/dataTypeConcerns/modelPropertyIncompatibleDataTypes";
import {
  BaseFormElementIncompatibleTypes,
  InputFormElementIncompatibleTypes
} from "~/models/mapping/dataTypeConcerns/formElementIncompatibleDataTypes";
import ModelMappingValueOriginSChildRelationship from "~/models/mapping/modelMappingValueOriginSChildRelationship";
import ModelMappingValueOriginSReferenceField from "~/models/mapping/modelMappingValueOriginSReferenceField";
import ModelMappingValueOriginRelationIdentifier from "~/models/mapping/modelMappingValueOriginRelationIdentifier";
import {ObjectModelRelationType} from "~/enums/objectModelRelationType";

export function getCategoryKey(otherSide) {
  if (otherSide instanceof ModelMappingValueOriginObjectModelProperty) {
    return "ObjectModelProperties";
  } else if (otherSide instanceof ModelMappingValueOriginSalesforce ||
    otherSide instanceof ModelMappingValueOriginSChildRelationship ||
    otherSide instanceof ModelMappingValueOriginSReferenceField) {
    return "Salesforce";
  } else if (otherSide instanceof ModelMappingValueOriginFormElement) {
    return "FormElement";
  } else if (otherSide instanceof ModelMappingValueOriginRelationIdentifier) {
    return otherSide.categoryKey
  }
}

export function getTypeValue(otherSide): SalesforceApiDataType | ObjectModelPropertyRootType | FormElementType | ObjectModelRelationType {
  if (otherSide instanceof ModelMappingValueOriginObjectModelProperty) {
    return otherSide.origin.property_type as ObjectModelPropertyRootType
  } else if (otherSide instanceof ModelMappingValueOriginSalesforce ||
    otherSide instanceof ModelMappingValueOriginSChildRelationship ||
    otherSide instanceof ModelMappingValueOriginSReferenceField) {
    return otherSide.valueType as SalesforceApiDataType
  } else if (otherSide instanceof ModelMappingValueOriginFormElement) {
    return otherSide.origin.element_type as FormElementType
  } else if (otherSide instanceof ModelMappingValueOriginRelationIdentifier) {
    return otherSide.originType as ObjectModelPropertyRootType | ObjectModelRelationType
  }
}


export function getTypeFormat(otherSide): InputFormatType | PickListSelectionType | SalesforceApiDataType {
  const otherType: ObjectModelPropertyRootType | FormElementType | SalesforceApiDataType | ObjectModelRelationType = getTypeValue(otherSide);
  if (otherSide instanceof ModelMappingValueOriginObjectModelProperty) {
    if ([ObjectModelPropertyRootType.Text, ObjectModelPropertyRootType.Number].includes(otherType as ObjectModelPropertyRootType)) {
      return otherSide.origin.format_type;
    } else if (otherType === ObjectModelPropertyRootType.PickList) {
      return otherSide.origin.selection_type
    } else {
      return null;
    }
  } else if (otherSide instanceof ModelMappingValueOriginFormElement) {
    if (otherType === FormElementType.textField) {
      return otherSide.origin.format_type
    }
  }
}

export function isInRules(rules, topLevelKey, otherSideKey, otherType, otherTypeFormat) {
  let parentSet = rules[topLevelKey]
  if (parentSet) {
    let ruleSet = parentSet[otherSideKey];
    if (ruleSet.includes(otherType)) return true;
    ruleSet.filter(r => isNaN(r)).forEach(r => {
      if (r[otherType]) {
        let formatRules = r[otherType];
        return formatRules.includes(otherTypeFormat);
      }
    })
  }
}


export function isDataTypeIncompatible(thisSide, otherSide) {
  const otherKey = getCategoryKey(otherSide);
  const otherType = getTypeValue(otherSide);
  const otherFormat = getTypeFormat(otherSide);
  let {baseRules, topLevelKey} = getRuleAndKey(thisSide);
  return isInRules(baseRules, topLevelKey, otherKey, otherType, otherFormat)
}


function getRuleAndKey(thisSide) {
  let baseRules;
  let topLevelKey;

  const thisType = getTypeValue(thisSide);
  const thisTypeFormat = getTypeFormat(thisSide);

  if (thisSide instanceof ModelMappingValueOriginObjectModelProperty) {
    if (thisType === omt.Text) {
      baseRules = shortTextModelPropertyIncompatibleTypes;
      topLevelKey = thisTypeFormat;
    } else if (thisType === omt.Number) {
      baseRules = numberModelPropertyIncompatibleTypes;
      topLevelKey = thisTypeFormat;
    } else if (thisType === omt.PickList) {
      baseRules = pickListModelPropertyIncompatibleTypes;
      topLevelKey = thisTypeFormat;
    } else if (thisType === omt.DateTime) {
      baseRules = dateTimeModelPropertyIncompatibleTypes;
      topLevelKey = thisTypeFormat;
    } else {
      baseRules = baseModelPropertyIncompatibleTypes;
      topLevelKey = thisType;
    }
  } else if (thisSide instanceof ModelMappingValueOriginSalesforce ||
    thisSide instanceof ModelMappingValueOriginSChildRelationship ||
    thisSide instanceof ModelMappingValueOriginSReferenceField) {
    // Salesforce presently is always "the other side"
    // so we don't need to worry about determining a rule set from it
    // order of thisSide/otherSide is determined in the this method's caller
  } else if (thisSide instanceof ModelMappingValueOriginFormElement) {
    if (thisType === FormElementType.textField) {
      baseRules = InputFormElementIncompatibleTypes;
      topLevelKey = thisTypeFormat;
    } else {
      baseRules = BaseFormElementIncompatibleTypes;
      topLevelKey = thisType;
    }
  }

  return {baseRules, topLevelKey}
}